// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".page-header-component[data-v-3d1877f3]{font-size:0;padding-bottom:5px;margin-bottom:10px;margin-left:0;margin-right:0;margin-top:10px}.page-header-component__label[data-v-3d1877f3]{font-size:28px;font-weight:600;line-height:28px;display:block}\n", ""]);
// Exports
module.exports = exports;
